<script setup lang="ts">
interface Props {
  label?: string
  required?: boolean
  error?: string | null
  info?: string | null
}

withDefaults(defineProps<Props>(), {
  required: false,
  error: null,
})
</script>

<template>
  <div class="flex flex-col gap-0.5">
    <div class="flex items-start justify-between gap-2">
      <label class="block w-full">
        <div class="relative">
          <div class="flex min-w-0 items-center gap-2 pr-8">
            <span>{{ label }}</span>
            <span v-if="required" class="-ml-1 text-sm text-[var(--p-red-600)]"> * </span>
            <InfoPopover :info />
          </div>
          <div class="absolute top-1/2 right-0 -translate-y-1/2">
            <slot name="labelActions" />
          </div>
        </div>
        <InputGroup>
          <slot />
        </InputGroup>
      </label>
    </div>

    <!--        <div class="h-5">-->
    <!--            <Message v-if="error" severity="error" size="small" variant="simple">-->
    <!--                {{ error }}-->
    <!--            </Message>-->
    <!--        </div>-->
  </div>
</template>
